<template>
  <a-input
    v-bind="$attrs"
    :value="value"
    :addon-after="addon"
    autocomplete="off"
    allow-clear
    @blur="onBlur"
    @change="onChange"
    @input="onInput"
    @keypress="numberDecimal"
  />
</template>

<script>
import { useInputNumber } from '@/composable/useInputNumber'

export default {
  name: 'InputNumberDecimal',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    addon: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { numberDecimal, toDecimalNumber } = useInputNumber()
    return { numberDecimal, toDecimalNumber }
  },
  methods: {
    formatIDR(value) {
      if (value === '' || value === null) return ''
      const num = this.toDecimalNumber(value)
      return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 2,
      }).format(num)
    },

    onInput(event) {
      const raw = event.target.value
      const formatted = this.formatIDR(raw)
      this.$emit('input', formatted)
    },

    onBlur(event) {
      this.$emit('blur', this.toDecimalNumber(event.target.value))
    },

    onChange(event) {
      this.$emit('change', this.toDecimalNumber(event.target.value))
    },
  },
};
</script>
